import extendNode from '../extendNode.mjs'
import useAbstractNode from '../_ABSTRACT/useAbstractNode.jsx'
import meta from './metaBdlogic_2.mjs'
import FormChoose from './FormChooseBdlogic_2.jsx'
import TableChoose from './TableChooseBdlogic_2.jsx'
import api from './apiBdlogic_2.mjs'

export default () => {
    const AbstractNode = useAbstractNode()

    return extendNode(AbstractNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,

        typeName(map, parent) {
            const {subTypeCode} = map?.data ?? {}

            if ('BODA1' === subTypeCode) {
                return '接口业务事务能力'
            }
            else {
                return '接口程序能力'
            }
        },
    })
}
